import React from 'react'
import Helmet from 'react-helmet'

import Gallery from '../components/Gallery'
import Layout from '../components/layout'
import Section, { Title, Body, Action } from '../components/Section'
import RoleList from '../components/Role'
import { ROLES, SUMMARY } from '../constants'

const HomeIndex = () => {
  const siteTitle = 'Emanuele di Vizio'
  const siteDescription = 'Software Engineer'

  return (
    <Layout>
      <Helmet>
        <title>{siteTitle}</title>
        <meta name="description" content={siteDescription} />
      </Helmet>

      <div id="main">
        <Section id="one">
          <Title>My experience</Title>
        </Section>

        <RoleList dataSource={ROLES} />

        <Section id="one">
          <Title>Get in Touch</Title>
          <Action title="Book a meeting with me on Calendly" link="https://calendly.com/emanuele-divizio"/>
        </Section>
      </div>
    </Layout>
  )
}

export default HomeIndex
